import { render, staticRenderFns } from "./AddLandPurchase.vue?vue&type=template&id=63df09e9"
import script from "./AddLandPurchase.vue?vue&type=script&lang=js"
export * from "./AddLandPurchase.vue?vue&type=script&lang=js"
import style0 from "./AddLandPurchase.vue?vue&type=style&index=0&id=63df09e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports